import { EPageComponentTypes } from 'models/route';
import { AuthPage } from 'pages/AuthPage';
import { AccessDeniedPage } from 'pages/AccessDeniedPage';
import { ServerErrorPage } from 'pages/ServerErrorPage';
import { NotFoundPage } from 'pages/NotFoundPage';
import { DashboardPage } from 'pages/DashboardPage';
import { ForgotPasswordPage } from 'pages/ForgotPasswordPage';
import { MyApplicationsPage } from 'pages/MyApplicationsPage';
import { ResetPasswordPage } from 'pages/ResetPasswordPage';
import { MyProfilePage } from 'pages/MyProfilePage';
import { EditAccountDataPage } from 'pages/MyProfilePage/EditAccountDataPage';
import { ApplyOnlinePage } from 'pages/ApplyOnlinePage';
import { ApplyOnlineWizardPage } from 'pages/ApplyOnlinePage/ApplyOnlineWizardPage';
import CustomOnePage from 'pages/CustomOnePage';
import CustomTwoPage from 'pages/CustomTwoPage';
import ApplicationDetailsPage from 'pages/MyApplicationsPage/ApplicationDetailsPage';

export const PageComponentTypes = {
  [EPageComponentTypes.AuthPage]: AuthPage,
  [EPageComponentTypes.ForgotPasswordPage]: ForgotPasswordPage,
  [EPageComponentTypes.ResetPasswordPage]: ResetPasswordPage,
  [EPageComponentTypes.NotFoundPage]: NotFoundPage,
  [EPageComponentTypes.AccessDeniedPage]: AccessDeniedPage,
  [EPageComponentTypes.ServerErrorPage]: ServerErrorPage,
  [EPageComponentTypes.DashboardPage]: DashboardPage,
  [EPageComponentTypes.MyApplicationsPage]: MyApplicationsPage,
  [EPageComponentTypes.ApplyOnlinePage]: ApplyOnlinePage,
  [EPageComponentTypes.ApplyOnlineWizardPage]: ApplyOnlineWizardPage,
  [EPageComponentTypes.MyProfile]: MyProfilePage,
  [EPageComponentTypes.EditAccountData]: EditAccountDataPage,
  [EPageComponentTypes.CustomOnePage]: CustomOnePage,
  [EPageComponentTypes.CustomTwoPage]: CustomTwoPage,
  [EPageComponentTypes.ApplicationDetails]: ApplicationDetailsPage,
};
